import { GQL_ID, PageInfo, Product, QueryVariablesTypes } from '@@types'
import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { SHORTCUT_PRODUCT_CARD_FIELDS, SHORTCUT_PRODUCT_FIELDS, SHORTCUT_PRODUCT_SHOP_INFO } from '@shared/api/shortcuts'

export interface FavoriteProductsVariables extends QueryVariablesTypes {
  shop_id: GQL_ID
  style?: string
}

export type FavoriteProductsData = {
  favoriteProducts: {
    edges: Product[]
    pageInfo: PageInfo
  }
}

export const GQL_QUERY_FAVORITE_PRODUCTS = gql`
  query favoriteProducts (
    $shop_id: ID!
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
    $style: String
  ) {
    favoriteProducts(
      shop_id: $shop_id
      filter: $filter
      pager: $pager
      sort: $sort
    ) {
      edges {
        ${SHORTCUT_PRODUCT_FIELDS}
        ${SHORTCUT_PRODUCT_CARD_FIELDS}
        ${SHORTCUT_PRODUCT_SHOP_INFO}
      }
      pageInfo {
        page
        perPage
        lastPage
        next
        total
      }
    }
  }
`

export const useFavoriteProducts = (variables: FavoriteProductsVariables) => {
  const { data, loading, error, refetch, fetchMore } = useQuery<FavoriteProductsData, FavoriteProductsVariables>(
    GQL_QUERY_FAVORITE_PRODUCTS, {
      variables,
      skip: !variables.shop_id
    }
  )

  const products = useMemo(() => data?.favoriteProducts?.edges ?? [], [ data?.favoriteProducts?.edges ])
  const pageInfo = useMemo(() => data?.favoriteProducts?.pageInfo, [ data?.favoriteProducts?.pageInfo ])

  return {
    data,
    products,
    pageInfo,
    loading,
    error,
    refetch,
    fetchMore
  }
}
